import values from 'mout/object/values'

export default function getCorrectAnswerLetter(item) {
  let correctAnswerIndex
  values(item.answers).forEach((answer, n) => {
    if (answer.correct) {
      correctAnswerIndex = n
    }
  })
  const lettering = {
    a: ['A', 'B', 'C', 'D', 'E'],
    f: ['F', 'G', 'H', 'J', 'K'],
  }
  return lettering[item.startingLetter][correctAnswerIndex]
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/getCorrectAnswerLetter.js